import { carouselData } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950">焦点专题</h2>
          <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-xl mx-auto">
            飞飞漫画网为你整理的漫画全集专题推荐，热门作品一站掌握
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {carouselData.map((item) => (
            <div
              key={item.id}
              className="group bg-background-100/60 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative overflow-hidden aspect-[16/7]">
                <img
                  src={item.image}
                  alt={item.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 via-transparent to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <span className="px-2.5 py-1 text-[11px] font-semibold bg-accent-500 text-background-50 rounded-md whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}